@import "../../global/gx-ide-mixins.scss";
@import "../../global/temporary-mercury-overrides/_button.scss";

$cardsCommonGap: var(--spacing-gap-xl);

:host {
  --common-spacing: var(--spacing-padding-xxl);
  --spacing-body-block-start: var(--common-spacing);
  --spacing-body-block-end: var(--common-spacing);
  --spacing-body-inline-start: var(--common-spacing);
  --spacing-body-inline-end: 0;
  --spacing-body-inline-start: 0;

  display: grid;
  block-size: 100%;
  overflow: auto;
}

// padding-inline-start and padding-inline-end should not apply on the host.
// This way the cards container (.section-create-new-kb__actions) can span full
:host(.spacing-body),
:host(.spacing-body-inline) {
  .section-secondary,
  .section-create-new-kb__header,
  .section-create-new-kb__actions {
    padding-inline-start: var(--common-spacing);
    padding-inline-end: var(--common-spacing);
  }
}
:host(.spacing-body-inline-start) {
  .section-secondary,
  .section-create-new-kb__actions {
    padding-inline-start: var(--common-spacing);
  }
}
:host(.spacing-body-inline-end) {
  .section-secondary,
  .section-create-new-kb__actions {
    padding-inline-end: var(--common-spacing);
  }
}
// - - - - - - - - - - - - - -
// General
// - - - - - - - - - - - - - -

.main {
  animation: fadeIn var(--timing-fast) forwards;
  display: grid;
  block-size: 100%;
  // overflow: visible;
  overflow: auto;
  opacity: 0;
  // grid-template-rows: max-content minmax(400px, 1fr);
  grid-template-rows: max-content 1fr;
  gap: var(--spacing-gap-xxl);
}

// - - - - - - - - - - - - - -
// Animations
// - - - - - - - - - - - - - -

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(
      calc(-1 * 32px)
    ); // 32px - closest available token to 30px
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

// - - - - - - - - - - - - - -
// Sections General Styles
// - - - - - - - - - - - - - -

.section-create-new-kb__actions,
.section-secondary__actions {
  display: grid;
  grid-auto-flow: column;
  gap: $cardsCommonGap;
  overflow-x: auto;
  padding-block-end: var(--spacing-padding-m);
}

// - - - - - - - - - - - - - -
// Cards
// - - - - - - - - - - - - - -

.card-filled,
.card-outlined {
  display: grid;
  gap: var(--spacing-gap-xl);
  align-content: space-between;
  border-radius: 8px;
}
.card-filled {
  background-color: var(--color-accent-surface-elevation-1);
  padding: var(--spacing-padding-xl);
}
.card-outlined {
  border: 1px solid var(--color-border-surface-on-surface);
  grid-template-columns: max-content 1fr;
  align-items: center;
  padding: var(--spacing-padding-xl) var(--spacing-padding-xl)
    var(--spacing-padding-m) var(--spacing-padding-xl);
}

.icon-capsule {
  $size: 40px;
  pointer-events: none;
  display: inline-flex;
  block-size: $size;
  inline-size: $size;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px dashed var(--color-border-surface-on-elevation-2);
}

.card__header {
  display: grid;
  gap: var(--spacing-gap-l);
  justify-items: self-start;
}
.card__header-description {
  display: grid;
  gap: var(--spacing-gap-m);
}

// - - - - - - - - - - - - - -
// Create a new Knowledge Base
// - - - - - - - - - - - - - -

.section-create-new-kb {
  display: grid;
  grid-auto-rows: max-content;
  gap: var(--spacing-gap-xxl);

  &__header {
    display: grid;
    gap: var(--spacing-gap-m);
  }

  &__title {
    color: var(--color-text-neutral-default);
  }

  &__actions {
    display: grid;
    gap: var(--spacing-gap-xl);
    overflow-x: auto;
    grid-auto-flow: column;
    grid-auto-columns: 330px;
  }
}

// View Samples Card
.samples-buttons-container {
  flex-wrap: wrap;
}

// - - - - - - - - - - - - - - - - - - - -
// Where to start / Recent Knowledge Bases
// - - - - - - - - - - - - - - - - - - - -

.section-secondary {
  display: grid;
  block-size: 100%;
  position: relative;
  overflow: auto;

  &__title {
    display: grid;
    grid-template-columns: 1fr max-content 1fr;
    gap: var(--spacing-gap-xl);
    align-items: center;

    &::before,
    &::after {
      content: "";
      block-size: 1px;
      background-color: var(--color-border-surface-on-elevation-1);
    }
  }

  &__actions {
    display: grid;
  }
  &__actions--two-cards {
    grid-template-columns: repeat(2, minmax(430px, 1fr));
  }
  &__actions--multiple-cards {
    grid-auto-columns: 670px;
  }
}
.section-no-kbs {
  display: grid;
  block-size: 100%;
  position: relative;
  overflow: auto;
  grid-template-rows: max-content max-content;
  gap: var(--spacing-gap-xl);
}

// - - - - - - - - - - - - - - - - - - - -
// Kbs
// - - - - - - - - - - - - - - - - - - - -

.section-kbs {
  background-color: var(--color-accent-surface-elevation-1);
  border-radius: 4px;
  padding: var(--spacing-padding-l);
  display: grid;
  container-type: inline-size;
  grid-template-rows: auto 1fr;
  overflow: hidden;

  &__header {
    display: grid;
    grid-template-columns: max-content 230px;
    align-items: center;
    gap: var(--spacing-gap-xxxl);
    border-block-end: 1px solid var(--color-border-surface-on-elevation-1);
    padding-block-end: var(--spacing-padding-l);

    &--no-border {
      border-block-end-color: transparent !important;
    }
  }
  &__title {
    //WA to prevent "FOUC" caused from .input
    align-items: center;
    display: flex;
    min-block-size: calc(32px - 1px);
  }
  &__filter--hidden {
    opacity: 0;
  }
  &__list {
    display: grid;
    grid-auto-rows: max-content;
    grid-template-columns: 1fr 1fr;
    row-gap: var(--spacing-gap-m);
    column-gap: var(--spacing-gap-xl);
    overflow: auto;
    position: relative;
    padding-block-start: var(--spacing-padding-l);

    &--empty {
      grid-template-columns: 1fr;
      grid-auto-rows: 1fr;
      overflow: hidden;
    }

    @container (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
}

.kb {
  &__item {
    background-color: var(--color-accent-surface-elevation-2);
    padding: var(--spacing-padding-l);
    display: grid;
    grid-template-columns: minmax(0, 1fr) max-content;
    align-items: center;
    column-gap: 48px;
  }
  &__details {
    display: grid;
    grid-template-columns: max-content minmax(0, 1fr);
    align-items: center;
    gap: var(--spacing-gap-l);
    overflow: hidden;
  }
  &__info {
    display: grid;
    gap: var(--spacing-gap-xs);
    overflow: hidden;
  }
  &__name {
    @include ellipsis();
    text-decoration: underline;
    cursor: pointer;
    display: inline-block;
    &:hover {
      color: var(--color-text-neutral-default);
    }
  }
  &__modified {
    @include ellipsis();
    text-align: end;
    font-variant-numeric: tabular-nums;
    color: var(--color-text-neutral-disabled);
  }
  &__path {
    @include ellipsis();
    color: var(--color-text-neutral-disabled);
  }
}

@include hiChar;

.loader {
  border: 1px solid var(--color-border-surface-on-surface);
}

// WA's / TODO's:
.heading-2,
.heading-3 {
  margin: 0; // remove titles margins, this should be done in Mercury probably
  color: #ffffff !important; // this color does not exists in mercury ds for dark theme.
}
.card-filled {
  .heading-3 {
    color: var(--color-text-neutral-strawberry) !important;
  }
}

.card__header-title {
  color: var(--color-text-neutral-default);
}

.button-tertiary-no-padding-inline-start.button-tertiary {
  // WA.
  padding-inline-start: 0;
}
